import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Skills.scss';

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);
  const [error, setError] = useState('');
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    const experienceQuery = '*[_type == "experiences"] | order(_createdAt desc)';
    const skillsQuery = '*[_type == "skills"] | order(name asc)';

    Promise.all([client.fetch(experienceQuery), client.fetch(skillsQuery)])
      .then(([experienceData, skillData]) => {
        setExperiences(experienceData);
        setSkills(skillData);
      })
      .catch(() => setError('Experience details could not be loaded right now.'));
  }, []);

  return (
    <>
      <div className="section-heading">
        <div>
          <p className="eyebrow">05 / Experience &amp; tools</p>
          <h2 className="head-text">Practice over <span>proficiency bars.</span></h2>
        </div>
        <p className="section-heading__copy">
          Production engineering across React, Next.js, APIs, and enterprise CMS
          work—supported by Python, machine learning, and computer vision tools.
        </p>
      </div>

      {error && <p className="status-message status-message--error" role="status">{error}</p>}

      <div className="skills-layout">
        <div>
          <p className="skills-label">Toolkit</p>
          <div className="app__skills-list">
            {skills.map((skill, index) => (
              <motion.div
                initial={reduceMotion ? false : { opacity: 0, scale: 0.92 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.4, delay: reduceMotion ? 0 : index * 0.035 }}
                className="app__skills-item"
                key={skill._id || skill.name}
              >
                <div style={skill.bgColor ? { backgroundColor: skill.bgColor } : undefined}>
                  {skill.icon && (
                    <img
                      src={urlFor(skill.icon).width(120).height(120).fit('max').auto('format').url()}
                      alt=""
                      loading="lazy"
                    />
                  )}
                </div>
                <p>{skill.name}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <div>
          <p className="skills-label">Experience</p>
          <div className="experience-list">
            {experiences.flatMap((experience) => (
              (experience.works || []).map((work, index) => (
                <motion.article
                  className="experience-item"
                  key={work._key || `${experience._id}-${work.name}`}
                  initial={reduceMotion ? false : { opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.35 }}
                  transition={{ duration: 0.45, delay: reduceMotion ? 0 : index * 0.05 }}
                >
                  <p className="experience-date">{experience.year}</p>
                  <h3>{work.name}</h3>
                  <p className="experience-company">{work.company}</p>
                  {work.desc && <p className="experience-description">{work.desc}</p>}
                </motion.article>
              ))
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__primarybg',
);
